<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Edit Inventory</h5>
            <hr />
            Pengubahan data inventory untuk Nomor Faktur <strong>{{ data.no_faktur }}</strong>, IMEI/SN <strong>{{ data.imei_sn}}</strong>
            <hr />
            <strong>DATA BARANG</strong>
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Tipe Barang">
                        <multiselect v-model="data.type"
                            label="name"
                            track-by="id"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optType"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group v-if="data.type.has_year == true" label="Tahun / Generasi Barang">
                        <b-form-select v-model="data.year" :options="optYear">
                            <template #first>
                                <b-select-option value=0 disabled>Pilih tahun...</b-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>PENILAIAN BARANG</strong>
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Grade Barang">
                        <b-form-select v-model="data.grade" :options="optGrade" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Kelengkapan Barang">
                        <b-form-select v-model="data.is_batangan" :options="optBatangan" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek Barang">
                        <b-form-select v-model="data.spec" :options="optSpec" :disabled="data.is_batangan" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <b-form-group label="Accessories yang Tidak Ada">
                        <multiselect v-model="data.accessories" :multiple="true"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optAccessories"
                            :close-on-select="false"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="calculatePrice">
                    {{ isSubmitting ? "Mohon menunggu..." : "Simpan" }}
                </b-button>
            </div>
        </b-card>
        <b-modal id="m-confirm" title="Konfirmasi Perubahan" size="md" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">Menghitung, mohon menunggu...</div>
            <div v-else>
                Harga barang mengikuti perubahan:
                <ul>
                    <li>Harga Dasar: Rp. {{ $helper.formatThousand(calculateResult.base) }}</li>
                    <li>Grade {{ data.grade }}: Rp. {{ $helper.formatThousand(calculateResult.grade) }}</li>
                    <li>Adjustment Batangan: Rp. {{ $helper.formatThousand(calculateResult.batangan) }}</li>
                    <li>Spek: Rp. {{ $helper.formatThousand(calculateResult.spec) }}</li>
                    <li>Harga Akhir: <strong>Rp. {{ $helper.formatThousand(finalPrice) }}</strong></li>
                </ul>
                <div class="mt-4 text-right">
                    <b-button variant="primary" :disabled="isSubmitting" @click="update">
                        {{ isSubmitting ? "Mengupdate..." : "Update" }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-success" title="Sukses" no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Data inventory berhasil diupdate!
            <div class="mt-4 text-right">
                <a target="_blank" :href="$BASE_PRINT_FILE_PATH + '/umgtbrcde/' + this.$route.params.id + '-___-' + this.data.no_faktur">
                    <b-button variant="dark">
                        <i class="fa fa-print mr-2" />Cetak Barcode Baru
                    </b-button>
                </a>
                <router-link to="/inventory" class="ml-2">
                    <b-button variant="primary">
                        Kembali
                    </b-button>
                </router-link>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            data: {},
            calculateResult: {},
            finalPrice: 0,

            optType: [],
            optYear: [],
            optGrade: ["A", "B", "C", "X"],
            optSpec: [
                { value: 1, text: "ORI" }
            ],
            optWarehouse: [],
            optBatangan: [
                { value: false, text: "Lengkap" },
                { value: true, text: "Batangan" }
            ],
            optAccessories: []

        }
    },

    watch: {

        "data.type": function(newVal, oldVal) {

            if(newVal == undefined || oldVal == undefined || newVal.id == oldVal.id) {
                return
            }

            this.data.year = 0;

            if(newVal.has_year == true) {

                this.$axios.get("master/years/" + newVal.id).then(res => {
                    let data = res.data.data
                    this.optYear = data.map(it => it.year)
                })

            }
            else {
                this.getOptions(true)
            }

        },

        "data.year": function(newVal, oldVal) {

            if(newVal == oldVal || newVal == 0) {
                return
            }

            this.getOptions(true)

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getDetail = this.$axios.get("inventory/edit/" + this.$route.params.id).then(res => {

                this.data = res.data.data
                this.optYear = res.data.data.opt_years
                this.optType = res.data.data.opt_types
                this.optAccessories = res.data.data.opt_accessories

            })

            Promise.all([getDetail]).then(res => {
                this.getOptions()
            })
            .catch(error => this.initStatus = -1)

        },

        getOptions(shouldReset = false) {

            let param = "?typeId=" + this.data.type.id
            if(this.data.year != null && this.data.year != 0) {
                param += "&year=" + this.data.year
            }

            this.$axios.get("inventory/edit/options" + param).then(res => {

                let data = res.data.data

                if(data.has_grade_s == true && this.optGrade.length == 4) {
                    this.optGrade.unshift("S")
                }
                else if(this.optGrade.length == 5) {
                    this.optGrade.splice(0, 1) // buang grade S
                }

                this.optSpec = [{ value: 1, text: "ORI" }]
                data.specs.forEach(it => {
                    this.optSpec.push({ value: it.id, text: it.name })
                })

                if(shouldReset) {
                    this.data.grade = "A"
                    this.data.spec = 1
                }

                this.initStatus = 1

            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        calculatePrice() {

            if(this.data.type.has_year == true && this.data.year == 0) {
                return this.$helper.toastError(this, "Mohon memilih tahun / generasi barang!")
            }

            this.isSubmitting = true
            this.isFetching = true
            this.$bvModal.show("m-confirm")

            let payload = {
                inventory_id: this.$route.params.id,
                grade: this.data.grade,
                is_batangan: this.data.is_batangan,
                spec: this.data.spec,
                type_id: this.data.type.id
            }

            if(this.data.year != null && this.data.year != 0) {
                payload.year = this.data.year
            }

            this.$axios.post("inventory/check-price-after-edit", payload).then(res => {

                let data = res.data.data
                this.calculateResult = data
                this.finalPrice = data.base + data.grade + data.batangan + data.spec
                this.isFetching = false

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        update() {

            let isConfirmed = confirm("Eksekusi perubahan ini?")
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                grade: this.data.grade,
                is_batangan: this.data.is_batangan,
                spec: this.data.spec,
                type_id: this.data.type.id,
                accessories: this.data.accessories.map(it => it.id)
            }

            if(this.data.year != null && this.data.year != 0) {
                payload.year = this.data.year
            }

            this.$axios.post("inventory/update/" + this.$route.params.id, payload).then(res => {

                this.$bvModal.hide("m-confirm")
                this.$bvModal.show("m-success")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    created() {
        this.init()
    }
}
</script>
